import { render } from "./Abt1a.vue?vue&type=template&id=f536ea24"
import script from "./Abt1a.vue?vue&type=script&lang=js"
export * from "./Abt1a.vue?vue&type=script&lang=js"

import "./Abt1a.vue?vue&type=style&index=0&id=f536ea24&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__